exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-data[data-v-3fdbd312] {\n    margin: 10px 0;\n    text-align: center;\n}\ntable[data-v-3fdbd312] {\n    margin: 0;\n}\n", ""]);

// exports
